import { render, staticRenderFns } from "./LicencesHoldbackGrid.vue?vue&type=template&id=27c0c1ae&scoped=true&"
import script from "./LicencesHoldbackGrid.vue?vue&type=script&lang=js&"
export * from "./LicencesHoldbackGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c0c1ae",
  null
  
)

export default component.exports